import { defineComponent as _defineComponent } from 'vue'
import { onMounted, ref } from 'vue';
import FontSelector from '@/components/DesignStudio/FontSelector.vue';
import CModal from '@/components/CModal.vue';
import { useFonts, type UserFont } from '@/composables/fonts';
import type { CanvaFont } from '@/typings/layers/layers';
import type {  CSelectItem, Primitive } from '@/components/shared/CSelect';
import fontManagerService from '@/utils/fontManagerService';

type FontReplacementInput = {
    fontReplaced: string;
    userFont: UserFont;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'FontsReplacementMatcherModal',
  props: {
    isOpen: { type: Boolean },
    isLoading: { type: Boolean },
    notFoundFonts: null
  },
  emits: ["fonts-replaced", "close"],
  setup(__props: any, { emit: emits }: { emit: ({
    (event: 'fonts-replaced', value: Map<string, UserFont>): void;
    (event: 'close'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
    isOpen: boolean;
    isLoading: boolean;
    notFoundFonts: CanvaFont[];
};

const fonts = useFonts();





const fontsReplaced = ref<FontReplacementInput[]>([]);

const toCSelectItem = (font: UserFont) => ({
    label: fonts.generateFontName(font),
    value: font.Path,
    name: font.Name,
    object: font
});

const onConfirm = () => {
    const fontsMap = new Map<string, UserFont>();
    for (const { fontReplaced, userFont } of fontsReplaced.value) {
        fontsMap.set(fontReplaced, userFont);
    }
    emits('fonts-replaced', fontsMap);
};

const onClose = () => {
    emits('close');
};

const onFontChange = (index: number, cselectItem: CSelectItem<Primitive>) => {
    fontsReplaced.value.splice(index, 1, { ...fontsReplaced.value[index], userFont: cselectItem.object as UserFont });
};

onMounted(() => {
    fontsReplaced.value =
        props.notFoundFonts.map(({ rawTypeface }) => ({
            fontReplaced: rawTypeface,
            userFont: fontManagerService.defaultFont
        })) || [];
});

return { __sfc: true,fonts, props, emits, fontsReplaced, toCSelectItem, onConfirm, onClose, onFontChange, FontSelector, CModal }
}

})